export function filter() {
    return {
      "data": [
        {
          "flexible_report_filter_id": 1,
          "flexible_report_filter_name": "NIP Lama",
          "flexible_report_filter_field": "employee_nip_old",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 2,
          "flexible_report_filter_name": "NIP Baru",
          "flexible_report_filter_field": "employee_nip",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 3,
          "flexible_report_filter_name": "Nama",
          "flexible_report_filter_field": "employee_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 4,
          "flexible_report_filter_name": "Unit Kerja",
          "flexible_report_filter_field": "employee_current_work_unit_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.view_work_unit_hirarki",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "work_unit_name_tabs,work_unit_name"
        },
        {
          "flexible_report_filter_id": 5,
          "flexible_report_filter_name": "Tempat lahir",
          "flexible_report_filter_field": "employee_place_of_birth_city_text",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 6,
          "flexible_report_filter_name": "Tanggal Lahir",
          "flexible_report_filter_field": "employee_date_of_birth",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "date",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 7,
          "flexible_report_filter_name": "Jenis Kelamin",
          "flexible_report_filter_field": "employee_gender_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "emp_gender",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "gender_name,gender_name"
        },
        {
          "flexible_report_filter_id": 8,
          "flexible_report_filter_name": "Agama",
          "flexible_report_filter_field": "employee_religion_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_religion",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "religion_name,religion_name"
        },
        {
          "flexible_report_filter_id": 9,
          "flexible_report_filter_name": "Status Perkawinan",
          "flexible_report_filter_field": "employee_marital_status_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_marital_status",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "marital_status_name,marital_status_name"
        },
        {
          "flexible_report_filter_id": 10,
          "flexible_report_filter_name": "Golongan Darah",
          "flexible_report_filter_field": "employee_blood_type_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_blood_type",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "blood_type_name,blood_type_name"
        },
        {
          "flexible_report_filter_id": 11,
          "flexible_report_filter_name": "E-mail",
          "flexible_report_filter_field": "employee_email_internal",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 12,
          "flexible_report_filter_name": "Alamat",
          "flexible_report_filter_field": "employee_domicile_address",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 15,
          "flexible_report_filter_name": "Telepon",
          "flexible_report_filter_field": "employee_mobile_phone_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 16,
          "flexible_report_filter_name": "Kode Pos",
          "flexible_report_filter_field": "employee_identity_postal_code",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 17,
          "flexible_report_filter_name": "Usia",
          "flexible_report_filter_field": "employee_age",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 18,
          "flexible_report_filter_name": "Tipe Pegawai",
          "flexible_report_filter_field": "employee_type_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_employee_type",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "employee_type_name,employee_type_name"
        },
        {
          "flexible_report_filter_id": 19,
          "flexible_report_filter_name": "Status Pegawai",
          "flexible_report_filter_field": "employee_status_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_employee_status",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "employee_status_name,employee_status_name"
        },
        {
          "flexible_report_filter_id": 20,
          "flexible_report_filter_name": "Kedudukan",
          "flexible_report_filter_field": "employee_status_position_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_employee_status_position",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "employee_status_position_name,employee_status_position_name"
        },
        {
          "flexible_report_filter_id": 21,
          "flexible_report_filter_name": "Jenis Pegawai",
          "flexible_report_filter_field": "employee_status_description_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_employee_status_description",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "employee_status_description_name,employee_status_description_name"
        },
        {
          "flexible_report_filter_id": 22,
          "flexible_report_filter_name": "Kartu Pegawai",
          "flexible_report_filter_field": "employee_karpeg_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 23,
          "flexible_report_filter_name": "Askes",
          "flexible_report_filter_field": "employee_askes_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 24,
          "flexible_report_filter_name": "Taspen",
          "flexible_report_filter_field": "employee_taspen_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 25,
          "flexible_report_filter_name": "NPWP",
          "flexible_report_filter_field": "employee_npwp_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 26,
          "flexible_report_filter_name": "NIK",
          "flexible_report_filter_field": "employee_identity_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 27,
          "flexible_report_filter_name": "Bank",
          "flexible_report_filter_field": "employee_bank_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_bank",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 28,
          "flexible_report_filter_name": "No Rekening",
          "flexible_report_filter_field": "employee_bank_account_number",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "number",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 29,
          "flexible_report_filter_name": "Tanggal Meninggal",
          "flexible_report_filter_field": "employee_date_of_death",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "date",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 30,
          "flexible_report_filter_name": "Tanggal Pensiun",
          "flexible_report_filter_field": "employee_date_of_pension",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "date",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 32,
          "flexible_report_filter_name": "Alamat KTP",
          "flexible_report_filter_field": "employee_identity_address",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "text",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 35,
          "flexible_report_filter_name": "TMT SK Jabatan",
          "flexible_report_filter_field": "employee_current_tmt_position",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "date",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 37,
          "flexible_report_filter_name": "Nama Jabatan",
          "flexible_report_filter_field": "employee_current_position_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.view_emp_position",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "position_name,position_name"
        },
        {
          "flexible_report_filter_id": 40,
          "flexible_report_filter_name": "TMT Pangkat",
          "flexible_report_filter_field": "employee_current_tmt_rank",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": null,
          "flexible_report_filter_type": "date",
          "flexible_report_filter_source_key_value": null
        },
        {
          "flexible_report_filter_id": 41,
          "flexible_report_filter_name": "Pangkat",
          "flexible_report_filter_field": "employee_current_rank_group_room",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_rank",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "rank_group_room,rank_group_room"
        },
        {
          "flexible_report_filter_id": 42,
          "flexible_report_filter_name": "Pendidikan",
          "flexible_report_filter_field": "employee_last_education_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "master.emp_education",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "education_name,education_name"
        },
        {
          "flexible_report_filter_id": 48,
          "flexible_report_filter_name": "Eselon",
          "flexible_report_filter_field": "echelon_name",
          "flexible_report_filter_status": 1,
          "flexible_report_filter_source": "emp_echelon",
          "flexible_report_filter_type": "select",
          "flexible_report_filter_source_key_value": "echelon_name,echelon_name"
        }
      ]
    }
};